import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-1 items-center justify-between" }
const _hoisted_2 = {
  href: "https://www.humelo.com/",
  target: "_blank",
  class: "mr-[30px] flex-shrink-0"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-between text-xs opacity-50" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Humelo Inc."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 사업자 등록번호: 416-86-03093  |  대표: 이자룡  |  서울특별시 서초구 강남대로 315 3층 (서울특별시 서초구 서초동 1338-23 3층) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "self-end" }, "Copyright © Humelo Inc. All rights reserved.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultContainer = _resolveComponent("DefaultContainer")!

  return (_openBlock(), _createBlock(_component_DefaultContainer, { class: "relative z-10 h-24 border-t-[1px] border-solid border-[rgba(131,144,165,0.3)] bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@assets/logo/humelo_logo.png'),
            alt: "humelo logo",
            class: "h-[28px]"
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4
      ])
    ]),
    _: 1
  }))
}